var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('task-filter',{on:{"change":_vm.onChange}}),_c('div',{staticClass:"right-container"},[_c('noticeboard-detail',{attrs:{"filter-form":_vm.filterForm}}),_c('br')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }